// Batch 3: East/Downtown Cairo & Highway Corridors (42 Areas)
export const areaContentBatch3 = {
  "مصر الجديدة": {
    tier: 1,
    title: "ونش انقاذ مصر الجديدة",
    metaDescription: "ونش انقاذ مصر الجديدة: الكوربة، روكسي، الميرغني، تريومف، شيراتون، العروبة، صلاح سالم. سطحة هيدروليك تصلك في 8-10 دقائق خدمة 24/7 بخصم 50% - اتصل 01044844492.",
    intro: "خدمة ونش إنقاذ عريقة واحترافية في مصر الجديدة (هليوبوليس) تغطي الكوربة، روكسي، الميرغني، تريومف، شيراتون المطار، والعروبة بأحدث أوناش السطحة الهيدروليكية ذات الزاوية المنخفضة خلال 8 إلى 10 دقائق على مدار الساعة.",
    responseTime: "8–10 دقائق في مصر الجديدة",
    dispatchPoints: [
      "ميدان الكوربة ومحيط نفق العروبة (الاستجابة: 7–9 دقائق)",
      "ميدان روكسي وتقاطع شارع الميرغني مع الأهرام (الاستجابة: 8–10 دقائق)",
      "ميدان تريومف وشارع الثورة ومحور حسين كامل (الاستجابة: 8–10 دقائق)",
      "مساكن شيراتون هليوبوليس ومحيط مطار القاهرة الدولي (الاستجابة: 10–12 دقيقة)"
    ],
    landmarks: [
      "قصر البارون إمبان الأثري",
      "ميدان الكوربة التاريخي",
      "ميدان روكسي وشارع الأهرام",
      "حديقة الميريلاند",
      "نادي هليوبوليس الرياضي",
      "مستشفى كليوباترا مصر الجديدة",
      "مستشفى هليوبوليس التخصصي",
      "ميدان تريومف",
      "سيتي سنتر ألماظة City Centre Almaza",
      "قصر الاتحادية الرئاسي"
    ],
    streets: [
      "شارع الأهرام (مصر الجديدة)",
      "شارع الميرغني",
      "شارع الثورة",
      "شارع العروبة (صلاح سالم)",
      "شارع بغداد (الكوربة)",
      "شارع بيروت",
      "شارع دمشق",
      "شارع الحجاز",
      "شارع عبد العزيز فهمي"
    ],
    localNotes: [
      "أوناش سطحة هيدروليكية كاملة بزاوية صفرية مخصصة للسيارات الكلاسيكية والفاخرة والرياضية المنتشرة بمصر الجديدة لحماية الشاسيه والصدادات.",
      "تغطية فورية وسريعة للأعطال على محور العروبة وصلاح سالم ومحيط نفق العروبة مع الالتزام الصارم بتأمين مسار السيارة وحركة السير.",
      "أوناش مدمجة تستطيع الدخول في الشوارع السكنية الهادئة بمصر الجديدة والكوربة دون إحداث أي ضوضاء أو احتكاك بالسيارات المصطفة.",
      "إمكانية نقل السيارة مباشرة إلى التوكيلات ومراكز الصيانة في جسر السويس ومصر الجديدة أو الحرفيين."
    ],
    faqs: [
      {
        "q": "كم يستغرق وصول ونش الإنقاذ في ميدان الكوربة أو روكسي بمصر الجديدة؟",
        "a": "يصلك الونش في غضون 7 إلى 10 دقائق لتواجد سيارات إنقاذ متمركزة بالقرب من ميدان الكوربة ونفق العروبة وميدان روكسي 24/7."
      },
      {
        "q": "هل يتوفر لديكم سطحة هيدروليك للسيارات الفارهة والكلاسيكية بمصر الجديدة؟",
        "a": "نعم، نوفر سطحات هيدروليكية كاملة (Full Flatbed) تنزل بمستوى الأرض تماماً بزاوية صفرية لضمان سلامة الصدادات والسيارات المنخفضة والفاخرة."
      },
      {
        "q": "ما هو بروتوكول التعامل في حالة تعطل السيارة على شارع صلاح سالم أو العروبة؟",
        "a": "نرسل أقرب ونش مجهز بإشارات تحذيرية ليد عالية الوضوح لتأمين السيارة وسحبها فوراً خارج نهر الطريق تفادياً للزحام والتصادم."
      },
      {
        "q": "هل تغطون منطقة مساكن شيراتون ومحيط مطار القاهرة الدولي؟",
        "a": "نعم، نوفر تغطية شاملة لمنطقة شيراتون هليوبوليس، ألماظة، طريق المطار، وسيتي سنتر ألماظة باستجابة فورية."
      },
      {
        "q": "هل أسعار ونش إنقاذ مصر الجديدة ثابتة وبدون رسوم إضافية؟",
        "a": "نعم، أسعارنا معلنة بخصم 50% ويتم تحديد التكلفة معك بدقة هاتفياً قبل تحرك الونش بدون أي رسوم خفية."
      }
    ],
    nearby: ["روكسي", "الميرغني", "تريومف", "ألماظة", "شيراتون", "النزهة", "مدينة نصر"]
  },

  "ألماظة": {
    tier: 2,
    title: "ونش انقاذ ألماظة مصر الجديدة",
    metaDescription: "ونش انقاذ ألماظة: سيتي سنتر ألماظة، محطة السوبر جيت، شارع الثورة، قاعدة ألماظة، طريق السويس. وصول 10 دقائق - 01044844492.",
    intro: "منطقة ألماظة نقطة الوصل الحيوية بين مصر الجديدة ومدينة نصر وطريق السويس. نوفر أوناش إنقاذ متمركزة أمام سيتي سنتر ألماظة ومحطة السوبر جيت للتدخل السريع على مدار 24 ساعة.",
    responseTime: "10 دقائق في ألماظة",
    landmarks: ["سيتي سنتر ألماظة City Centre Almaza", "محطة السوبر جيت ألماظة", "مستشفى ألماظة العسكري", "نادي الجلاء للقوات المسلحة", "قاعدة ألماظة الجوية"],
    streets: ["شارع الثورة", "طريق النصر", "شارع حسين كامل المجيد", "طريق السويس (بداية ألماظة)", "شارع عمر بن الخطاب"],
    localNotes: ["تغطية لحالات الطوارئ بمواقف وجراجات سيتي سنتر ألماظة ومحطة الأتوبيسات الدولية.", "انطلاق فوري نحو طريق السويس أو كوبري الجيش ومحور المشير."],
    faqs: [
      {
            "q": "هل يتوفر ونش عند سيتي سنتر ألماظة ومحطة السوبر جيت؟",
            "a": "نعم، أوناشنا متواجدة على شارع الثورة أمام سيتي سنتر ألماظة 24/7."
      }
,
      {
        "q": "هل تخدمون منطقة ألماظة بالقرب من قاعدة الجوية؟",
        "a": "نعم، نغطي ألماظة بالكامل بما في ذلك المنطقة المحيطة بالقاعدة الجوية وسيتي سنتر والأتوبيسات الدولية."
      }],
    nearby: ["مصر الجديدة", "شيراتون", "مدينة نصر", "طريق السويس", "النزهة"]
  },

  "روكسي": {
    tier: 2,
    title: "ونش انقاذ ميدان روكسي مصر الجديدة",
    metaDescription: "ونش انقاذ روكسي: شارع الأهرام، حديقة الميريلاند، شارع القبة، جراج روكسي الذكي، كوبري القبة. وصول 5-10 دقائق - 01044844492.",
    intro: "ميدان روكسي المركز التجاري الأول بمصر الجديدة. نوفر أوناش إنقاذ متمركزة بجوار جراج روكسي وحديقة الميريلاند لإنقاذ وسحب سيارات الملاكي بكفاءة عالية وأرخص الأسعار.",
    responseTime: "5–10 دقائق في روكسي",
    landmarks: ["ميدان روكسي الشهير", "جراج روكسي الإلكتروني الذكي", "حديقة الميريلاند", "سينما روكسي", "مستشفى القوات المسلحة بمصر الجديدة"],
    streets: ["شارع الأهرام", "شارع الخليفة المأمون", "شارع الميرغني", "شارع دمشق", "شارع غرناطة"],
    localNotes: ["أوناش مدمجة للتعامل مع زحام شوارع روكسي التجارية وسحب السيارات بدون تعطيل الحركة.", "توفير خدمات وصلة البطارية وتزويد الوقود وتغيير الإطارات في الموقع."],
    faqs: [
      {
            "q": "هل يستطيع الونش سحب سيارة متعطلة بجوار حديقة الميريلاند أو ميدان روكسي؟",
            "a": "نعم، نصلك في دقائق معدودة ونقوم بسحب السيارة بأمان تام."
      }
,
      {
        "q": "هل تغطون الجراجات متعددة الطوابق بمنطقة روكسي؟",
        "a": "نعم، جراج روكسي وكل جراجات مصر الجديدة مغطاة بأوناش مدمجة مجهزة للدخول والمناورة في الجراجات المتعددة."
      }],
    nearby: ["مصر الجديدة", "الميرغني", "تريومف", "حدائق القبة", "الزيتون", "سراي القبة"]
  },

  "الميرغني": {
    tier: 2,
    title: "ونش انقاذ شارع الميرغني مصر الجديدة",
    metaDescription: "ونش انقاذ شارع الميرغني: من ميدان روكسي حتى قصر الاتحادية ومحطة مترو الأهرام وكلية البنات. وصول 5-10 دقائق - 01044844492.",
    intro: "شارع الميرغني من أرقى وأهم محاور مصر الجديدة. أوناش إنقاذ محمد بحر متمركزة لخدمة المحلات التجارية والشركات ومحيط قصر الاتحادية ومحطة مترو كلية البنات طوال 24 ساعة.",
    responseTime: "5–10 دقائق في الميرغني",
    landmarks: ["قصر الاتحادية الرئاسي", "محطة مترو الأهرام", "محطة مترو كلية البنات", "نادي هليوبوليس (بوابة الميرغني)", "مستشفى هليوبوليس"],
    streets: ["شارع الميرغني الرئيسي", "شارع الثورة", "شارع نزيه خليفة", "شارع نهرو", "شارع الخليفة المأمون"],
    localNotes: ["أوناش سطحة هيدروليكية مؤمنة بالكامل لحماية هياكل السيارات الفاخرة.", "تأمين فوري للسيارات المتعطلة على جانبي مسار المترو بشارع الميرغني."],
    faqs: [
      {
            "q": "كم يستغرق وصول ونش الإنقاذ في شارع الميرغني؟",
            "a": "يصل الونش خلال أقل من 10 دقائق لتواجدنا المستمر على المحور."
      }
,
      {
        "q": "ما أسرع وقت وصول على شارع الميرغني أمام قصر الاتحادية؟",
        "a": "نصل عادةً في 5-10 دقائق. شارع الميرغني من أولويات تمركز أوناشنا نظراً لأهميته وكثافة حركة المرور."
      }],
    nearby: ["مصر الجديدة", "روكسي", "تريومف", "كلية البنات", "شارع الثورة", "مدينة نصر"]
  },

  "تريومف": {
    tier: 2,
    title: "ونش انقاذ ميدان تريومف مصر الجديدة",
    metaDescription: "ونش انقاذ تريومف: شارع الحجاز، شارع عثمان بن عفان، كنيسة البازيليك، مستشفى تريومف. وصول 5-10 دقائق بخصم 50% - 01044844492.",
    intro: "ميدان تريومف القلب الهادئ لمصر الجديدة. نوفر خدمة إنقاذ سيارات متخصصة تغطي ميدان تريومف وشارع عثمان بن عفان وامتداد شارع الحجاز وكنيسة البازيليك ومستشفى تريومف على مدار 24 ساعة.",
    responseTime: "5–10 دقائق في تريومف",
    landmarks: ["ميدان تريومف الرئيسي", "كنيسة البازيليك التاريخية", "مستشفى تريومف التخصصي", "مدرسة الفرير بمصر الجديدة", "ميدان الإسماعيلية"],
    streets: ["شارع عثمان بن عفان", "شارع الحجاز", "شارع بيروت", "شارع الإمام علي", "شارع هارون الرشيد"],
    localNotes: ["أوناش مجهزة للتحرك في الشوارع الهادئة والشوارع الدائرية المحيطة بميدان تريومف.", "خدمة فورية لنقل السيارات المعطلة لأفضل مراكز الخدمة بمصر الجديدة ومدينة نصر."],
    faqs: [
      {
            "q": "هل يتوفر ونش إنقاذ بمحيط ميدان تريومف وشارع عثمان بن عفان؟",
            "a": "نعم، أوناشنا متواجدة بميدان تريومف على مدار 24 ساعة."
      }
,
      {
        "q": "هل تخدمون ميدان تريومف وشارع عبد المنعم رياض المتفرع منه؟",
        "a": "نعم، ميدان تريومف وكل الشوارع المتفرعة باتجاه روكسي والميرغني والكوربة مغطاة بخدمتنا الكاملة."
      }],
    nearby: ["مصر الجديدة", "شارع الحجاز", "الميرغني", "روكسي", "النزهة", "سانت فاتيما"]
  },

  "شارع الحجاز": {
    tier: 2,
    title: "ونش انقاذ شارع الحجاز مصر الجديدة",
    metaDescription: "ونش انقاذ شارع الحجاز: من حديقة الميريلاند حتى ميدان المحكمة وميدان الحجاز ونادي الشمس. وصول 10 دقائق - 01044844492.",
    intro: "شارع الحجاز يربط قلب مصر الجديدة بميدان المحكمة ونادي الشمس وجسر السويس. أوناشنا متمركزة عند ميدان الحجاز وميدان المحكمة لتغطية سريعة وشاملة طوال 24 ساعة.",
    responseTime: "10 دقائق في شارع الحجاز",
    landmarks: ["ميدان الحجاز", "ميدان المحكمة ومحكمة مصر الجديدة", "نادي الشمس الرياضي (بوابة الحجاز)", "مستشفى هليوبوليس", "مستشفى فلسطين"],
    streets: ["شارع الحجاز الرئيسي", "شارع عبد العزيز فهمي", "شارع النزهة", "شارع فريد سميكة", "شارع عمار بن ياسر"],
    localNotes: ["تغطية سريعة لرواد نادي الشمس والمترددين على المستشفيات والعيادات بشارع الحجاز.", "توفير خدمات الطوارئ للبطاريات والإطارات وتزويد الوقود في الموقع."],
    faqs: [
      {
            "q": "كم يستغرق وصول ونش الإنقاذ عند ميدان المحكمة أو ميدان الحجاز؟",
            "a": "أقل من 10 دقائق لتواجد أوناشنا المباشر عند ميدان الحجاز."
      }
,
      {
        "q": "كم يستغرق الوصول في شارع الحجاز بين ميدانَي تريومف والحجاز؟",
        "a": "5-10 دقائق. شارع الحجاز نقطة تمركز رئيسية لأسطولنا في مصر الجديدة."
      }],
    nearby: ["مصر الجديدة", "تريومف", "النزهة", "جسر السويس", "نادي الشمس", "عين شمس"]
  },

  "شيراتون": {
    tier: 1,
    title: "ونش انقاذ شيراتون مصر الجديدة",
    metaDescription: "ونش انقاذ مساكن شيراتون: صن سيتي مول، فندق راديسون، طريق المطار، كوبري عبد الحميد بدوي، الأوتوستراد. وصول 10 دقائق بخصم 50% - 01044844492.",
    intro: "مساكن شيراتون هليوبوليس البوابة الدبلوماسية والسياحية لمطار القاهرة الدولي. أوناش إنقاذ محمد بحر متمركزة في شارع عبد الحميد بدوي ومحيط صن سيتي مول وفندق راديسون بلو لإنقاذ فوري على مدار 24 ساعة.",
    responseTime: "10 دقائق في شيراتون",
    landmarks: ["صن سيتي مول Sun City Mall", "فندق راديسون بلو شيراتون", "الأكاديمية العربية للعلوم والتكنولوجيا (فرع شيراتون)", "مطار القاهرة الدولي صالة 1 و 3", "فندق الشيراتون هليوبوليس"],
    streets: ["شارع عبد الحميد بدوي", "طريق المطار", "طريق الأوتوستراد (مدخل شيراتون)", "شارع المشير أحمد إسماعيل", "شارع الصاعقة"],
    localNotes: ["أوناش هيدروليكية حديثة لنقل سيارات المسافرين وسيارات الوفود الدبلوماسية ورجال الأعمال.", "تأمين فوري وسريع للأعطال على طريق المطار وطريق الصاعقة ومحيط الأكاديمية البحرية."],
    faqs: [
      {
            "q": "هل تغطون مطار القاهرة الدولي ومساكن شيراتون؟",
            "a": "نعم، أوناشنا متمركزة أمام صالات المطار ومساكن شيراتون على مدار 24 ساعة."
      }
,
      {
        "q": "هل تخدمون مساكن شيراتون والطريق الجديد المؤدي للمطار؟",
        "a": "نعم، مساكن شيراتون وطريق المطار الجديد والقرية الذكية ومداخل المطار مغطاة 24 ساعة."
      }],
    nearby: ["مصر الجديدة", "ألماظة", "النزهة الجديدة", "طريق السويس", "الأوتوستراد", "الهايكستب"]
  },

  "النزهة": {
    tier: 2,
    title: "ونش انقاذ النزهة مصر الجديدة",
    metaDescription: "ونش انقاذ النزهة: شارع عثمان بن عفان، سانت فاتيما، ميدان تريومف، محطة مترو النزهة. وصول 10 دقائق خدمة 24/7 - 01044844492.",
    intro: "حي النزهة العريق بمصر الجديدة. نوفر أوناش إنقاذ متواجدة بمحيط ميدان سانت فاتيما وشارع عمار بن ياسر وشارع فريد سميكة لنقل وسحب كافة أنواع المركبات بأعلى احترافية.",
    responseTime: "10 دقائق في النزهة",
    landmarks: ["ميدان سانت فاتيما", "محطة مترو النزهة", "مستشفى النزهة الدولي", "نادي الطيران الرياضي", "الكلية الحربية (بالقرب)"],
    streets: ["شارع عمار بن ياسر", "شارع فريد سميكة", "شارع النزهة الرئيسي", "شارع عبد العزيز فهمي", "شارع عثمان بن عفان"],
    localNotes: ["تمركز بالقرب من مستشفى النزهة الدولي وسانت فاتيما لخدمة الحالات الطارئة.", "جاهزية كاملة لإنقاذ السيارات وسحبها في أوقات الذروة بأمان واحترافية."],
    faqs: [
      {
            "q": "كم يستغرق وصول ونش الإنقاذ إلى ميدان سانت فاتيما بالنزهة؟",
            "a": "يصل الونش خلال أقل من 10 دقائق لتواجدنا الدائم بمحيط سانت فاتيما."
      }
,
      {
        "q": "هل تغطون النزهة الجديدة والمناطق الجديدة المتفرعة منها؟",
        "a": "نعم، النزهة القديمة والجديدة وعين شمس الجنوبية ومنطقة ستاد النزهة مغطاة كاملاً."
      }],
    nearby: ["النزهة الجديدة", "مصر الجديدة", "تريومف", "شارع الحجاز", "شيراتون", "جسر السويس"]
  },

  "النزهة الجديدة": {
    tier: 2,
    title: "ونش انقاذ النزهة الجديدة",
    metaDescription: "ونش انقاذ النزهة الجديدة: شارع طه حسين، محور چوزيف تيتو، سوق القنطرة، محطة مترو هشام بركات. وصول 10 دقائق بخصم 50% - 01044844492.",
    intro: "خدمة ونش إنقاذ متكاملة في النزهة الجديدة، نغطي شارع طه حسين التجاري، محور جوزيف تيتو، سوق القنطرة، ومحيط الهايكستب وطريق المطار على مدار 24 ساعة.",
    responseTime: "10 دقائق في النزهة الجديدة",
    landmarks: ["شارع طه حسين التجاري", "محطة مترو هشام بركات", "محور چوزيف تيتو", "سوق القنطرة بالنزهة الجديدة", "مستشفى السعودي الألماني (بالقرب)"],
    streets: ["شارع طه حسين", "محور چوزيف تيتو", "شارع محمد كامل حسين", "شارع المدينة المنورة", "طريق السندباد"],
    localNotes: ["أوناش متواجدة على محور جوزيف تيتو لسرعة التحرك نحو المطار أو طريق الإسماعيلية.", "توفير خدمات سحب فورية لسيارات الملاكي والميكروباص والنقل الخفيف."],
    faqs: [
      {
            "q": "هل تغطون شارع طه حسين ومحور جوزيف تيتو بالنزهة الجديدة؟",
            "a": "نعم، التغطية تشمل شارع طه حسين وجوزيف تيتو ومداخل الحرفيين بالكامل."
      }
,
      {
        "q": "ما الفرق في زمن الوصول بين النزهة القديمة والجديدة؟",
        "a": "زمن الوصول متقارب: 10-15 دقيقة لكليهما بسبب تمركز أوناشنا بين الاثنتين."
      }],
    nearby: ["النزهة", "چوزيف تيتو", "شيراتون", "الهايكستب", "الحرفيين", "جسر السويس"]
  },

  "الهايكستب": {
    tier: 2,
    title: "ونش انقاذ الهايكستب",
    metaDescription: "ونش انقاذ الهايكستب: طريق مصر الإسماعيلية الصحراوي، سوق العبور، محور جوزيف تيتو، معسكرات الهايكستب. وصول 10-15 دقيقة - 01044844492.",
    intro: "منطقة الهايكستب بوابة القاهرة الشرقية على طريق الإسماعيلية الصحراوي. نوفر أوناش إنقاذ متمركزة عند مدخل الهايكستب وسوق العبور ومحور جوزيف تيتو لخدمة السيارات الملاكي والنقل.",
    responseTime: "10–15 دقيقة في الهايكستب",
    landmarks: ["منطقة معسكرات وتجنيد الهايكستب", "سوق العبور للجملة (المدخل)", "محطة عدلي منصور التبادلية (بالقرب)", "مستشفى الهايكستب العسكري"],
    streets: ["طريق القاهرة - الإسماعيلية الصحراوي", "محور چوزيف تيتو", "طريق الهايكستب الرئيسي", "شارع جمال عبد الناصر السلام"],
    localNotes: ["أوناش ثقيلة وسطحات مجهزة لخدمة شاحنات البضائع وسيارات الركاب على مدخل الإسماعيلية.", "تأمين سريع للسيارات المتعطلة على الحارات السريعة وتفادي الحوادث."],
    faqs: [
      {
            "q": "هل توفرون ونش سحب للسيارات والشاحنات في منطقة الهايكستب؟",
            "a": "نعم، لدينا أوناش ملاكي وأوناش ثقيلة متمركزة بالهايكستب 24/7."
      }
,
      {
        "q": "هل تخدمون منطقة الهايكستب والمناطق الصناعية القريبة منها؟",
        "a": "نعم، الهايكستب والخصوص وشبرا الخيمة الصناعية مغطاة بأسطولنا ضمن منطقة شمال القاهرة."
      }],
    nearby: ["النزهة الجديدة", "چوزيف تيتو", "طريق الإسماعيلية", "مدينة السلام", "العبور", "الحرفيين"]
  },

  "چوزيف تيتو": {
    tier: 2,
    title: "ونش انقاذ محور چوزيف تيتو",
    metaDescription: "ونش انقاذ محور چوزيف تيتو: من شيراتون والنزهة حتى الهايكستب وطريق الإسماعيلية ومطار القاهرة. وصول 10 دقائق - 01044844492.",
    intro: "محور چوزيف تيتو الشريان السريع الرابط بين مصر الجديدة ومطار القاهرة وطريق الإسماعيلية الصحراوي. أوناشنا متمركزة على المحور للتدخل الفوري عند أي عطل أو حادث على مدار 24 ساعة.",
    responseTime: "10 دقائق على محور جوزيف تيتو",
    landmarks: ["محور چوزيف تيتو السريع", "نادي حرس الحدود (فرع الهايكستب)", "مدخل النزهة الجديدة", "كوبري الحرفيين العلوي"],
    streets: ["محور چوزيف تيتو", "طريق المطار", "شارع طه حسين", "طريق الإسماعيلية الصحراوي", "شارع جمال عبد الناصر"],
    localNotes: ["أوناش سريعة ومجهزة بإشارات ضوئية تحذيرية لتأمين حارات المحور السريعة.", "انطلاق فوري نحو النزهة الجديدة أو الحرفيين أو طريق الإسماعيلية."],
    faqs: [
      {
            "q": "كم يستغرق وصول ونش الإنقاذ على محور جوزيف تيتو؟",
            "a": "يصل الونش خلال أقل من 10 دقائق لتواجد سياراتنا الدائم على طول المحور."
      }
,
      {
        "q": "هل تغطون شارع جوزيف تيتو والمنطقة الواقعة بين مصر الجديدة والنزهة؟",
        "a": "نعم، شارع جوزيف تيتو والمناطق بينه وبين الزيتون والنزهة ومصر الجديدة مغطاة كاملاً 24 ساعة."
      }],
    nearby: ["النزهة الجديدة", "شيراتون", "الهايكستب", "طريق الإسماعيلية", "الحرفيين"]
  },

  "المطرية": {
    tier: 2,
    title: "ونش انقاذ المطرية",
    metaDescription: "ونش انقاذ المطرية: ميدان المطرية، شجرة مريم، مستشفى المطرية التعليمي، مسلة سنوسرت، كوبري مسطرد. وصول 10-15 دقيقة - 01044844492.",
    intro: "خدمة ونش إنقاذ سريعة في المطرية ومحيط شجرة مريم ومسلة سنوسرت وميدان المطرية وكوبري مسطرد؛ أوناش سحب مدمجة تصلك خلال 10 إلى 15 دقيقة على مدار 24 ساعة.",
    responseTime: "10–15 دقيقة في المطرية",
    landmarks: ["ميدان المطرية الرئيسي", "شجرة مريم الأثرية", "مستشفى المطرية التعليمي", "مسلة سنوسرت الأول (المسلة)", "محطة مترو المطرية"],
    streets: ["شارع المطرية العمومي", "شارع الترعة التوفيقية", "شارع ترعة الجبل", "شارع الحرية", "شارع الكابلات"],
    localNotes: ["أوناش شوكة مدمجة تناسب شوارع المطرية الشعبية المزدحمة وتتحرك بمرونة في محيط سوق الخميس والتروللي.", "سرعة تأمين وإخلاء السيارات المعطلة على محور مسطرد وكوبري المطرية الجديد لتفادي التكدس.", "قرب المسافة لنقل السيارة لورش الحرفيين أو ميكانيكا جسر السويس ومصر الجديدة."],
    faqs: [
      {
            "q": "كم يستغرق وصول ونش الإنقاذ عند ميدان المطرية؟",
            "a": "يصل الونش في غضون 10 دقائق لتواجد نقطة تمركز قريبة عند كوبري مسطرد ومحور المطرية الجديد."
      },
      {
            "q": "لو الموتور سخن والعربية وقفت في المطرية هل تقدمون مساعدة؟",
            "a": "نعم، نرسل ونشاً وميكانيكياً طوارئ لتزويد مياه الردياتير أو سحب السيارة لأقرب ورشة متخصصة بأمان."
      }
],
    nearby: ["عين شمس", "حلمية الزيتون", "جسر السويس", "مسطرد", "الزيتون", "حدائق القبة"]
  },

  "جسر السويس": {
    tier: 1,
    title: "ونش انقاذ جسر السويس",
    metaDescription: "ونش انقاذ شارع جسر السويس: من إشارة روكسي والتجنيد حتى الألف مسكن وعرب الجسر ومحطة عدلي منصور. وصول 10 دقائق خدمة 24/7 - 01044844492.",
    intro: "خدمة ونش إنقاذ على امتداد شارع جسر السويس من ألف مسكن وحديقة بدر حتى الأربعين ومحطة مترو النزهة؛ أوناش سحب سريعة تتفادى الزحام وتصلك خلال 10 إلى 15 دقيقة.",
    responseTime: "10–15 دقيقة في جسر السويس",
    landmarks: ["ميدان الألف مسكن", "موقف ومحطة مترو عدلي منصور المركزية", "نادي الشمس الرياضي (بوابة جسر السويس)", "ميدان التجنيد ومحكمة التجنيد", "سوق القنطرة", "مستشفى اليوم الواحد"],
    streets: ["شارع جسر السويس الرئيسي", "شارع 6 أكتوبر (جسر السويس)", "شارع أحمد عصمت", "شارع الخمسين السلام", "شارع سنان باشا"],
    localNotes: ["أوناش شوكة مدمجة تتفادى الزحام وتناور بسلاسة بمحيط مسار قطار المترو الجديد ومحلات قطع الغيار.", "سرعة رفع السيارة لتفادي شل حركة المرور بميادين الألف مسكن والتجنيد ونادي الشمس.", "قرب المسافة لنقل السيارة لورش الحرفيين أو ميكانيكا مصر الجديدة وميدان الحجاز."],
    faqs: [
      {
            "q": "كم يستغرق الونش للوصول عند ميدان الألف مسكن بجسر السويس؟",
            "a": "يصل الونش في غضون 10 دقائق لتمركز سياراتنا بالقرب من ميدان التجنيد وجسر السويس."
      },
      {
            "q": "هل تسحبون السيارات المعطلة أمام محطات المترو في جسر السويس؟",
            "a": "نعم، نتحرك فوراً لإخلاء محيط محطات المترو وتأمين السيارة لعدم إعاقة حركة الركاب."
      }
],
    nearby: ["ألف مسكن", "عين شمس", "حلمية الزيتون", "مصر الجديدة", "الحرفيين", "مدينة السلام"]
  },

  "حلمية الزيتون": {
    tier: 2,
    title: "ونش انقاذ حلمية الزيتون",
    metaDescription: "ونش انقاذ حلمية الزيتون: ميدان ابن الحكم، محطة مترو حلمية الزيتون، كوبري الحلمية، شارع سليم الأول. وصول 10 دقائق - 01044844492.",
    intro: "تغطية متميزة لإنقاذ السيارات في حلمية الزيتون، نخدم ميدان ابن الحكم، محطة مترو حلمية الزيتون، شارع سليم الأول، وكوبري الحلمية العلوي بأحدث أوناش السحب السريعة.",
    responseTime: "10 دقائق في حلمية الزيتون",
    landmarks: ["ميدان ابن الحكم", "محطة مترو حلمية الزيتون", "كوبري الحلمية العلوي", "مستشفى الحلمية العسكري للعظام", "قصر الطاهرة"],
    streets: ["شارع سليم الأول", "شارع ابن الحكم", "شارع عين شمس (مدخل الحلمية)", "شارع المسلة", "شارع عزيز المصري"],
    localNotes: ["موقع وسطي يربط بين مصر الجديدة والمطرية وعين شمس والزيتون.", "توفير خدمات الطوارئ الميدانية لشحن البطاريات وتغيير الإطارات وتزويد الوقود."],
    faqs: [
      {
            "q": "هل يتوفر ونش عند ميدان ابن الحكم ومحطة مترو حلمية الزيتون؟",
            "a": "نعم، أوناشنا متواجدة بميدان ابن الحكم على مدار 24 ساعة."
      }
,
      {
        "q": "هل تغطون حلمية الزيتون والمنطقة بين الزيتون والمطرية؟",
        "a": "نعم، حلمية الزيتون وامتداداتها نحو الزيتون والمطرية وعين شمس مغطاة بالكامل."
      }],
    nearby: ["الزيتون", "عين شمس", "المطرية", "مصر الجديدة", "جسر السويس", "سراي القبة"]
  },

  "عين شمس": {
    tier: 2,
    title: "ونش انقاذ عين شمس",
    metaDescription: "ونش انقاذ عين شمس الشرقية والغربية: شارع أحمد عصمت، مصطفى حافظ، محطة مترو عين شمس، منشية التحرير. وصول 10-15 دقيقة بخصم 50% - 01044844492.",
    intro: "خدمة ونش إنقاذ وسحب سيارات متواجدة على مدار 24 ساعة في عين شمس (الشرقية والغربية)، نغطي شارع أحمد عصمت، شارع مصطفى حافظ، محطة المترو، والشوارع المتفرعة نحو جسر السويس.",
    responseTime: "10–15 دقيقة في عين شمس",
    landmarks: ["محطة مترو عين شمس", "شارع أحمد عصمت التجاري", "شارع مصطفى حافظ", "ميدان نعام", "مجمع محاكم مصر الجديدة وعين شمس"],
    streets: ["شارع أحمد عصمت", "شارع مصطفى حافظ", "شارع عين شمس العمومي", "شارع 6 أكتوبر عين شمس", "شارع العشرين عين شمس"],
    localNotes: ["أوناش مدمجة تتحرك بسلاسة في شوارع عين شمس المزدحمة وتصل للعميل بأمان.", "تغطية شاملة للمنافذ الرابطة مع جسر السويس ومزلقانات المترو."],
    faqs: [
      {
            "q": "كم يستغرق وصول ونش الإنقاذ بشارع أحمد عصمت بعين شمس؟",
            "a": "يصل الونش خلال 10 إلى 15 دقيقة من أقرب نقطة تمركز بجسر السويس."
      }
,
      {
        "q": "هل تخدمون المنطقة الصناعية في عين شمس والحرفيين القريبة منها؟",
        "a": "نعم، عين شمس الصناعية والسكنية وحي الحرفيين والمنطقة الصناعية في الشرقية مغطاة كلها."
      }],
    nearby: ["ألف مسكن", "جسر السويس", "حلمية الزيتون", "المطرية", "الزيتون", "مدينة السلام"]
  },

  "ألف مسكن": {
    tier: 2,
    title: "ونش انقاذ الألف مسكن جسر السويس",
    metaDescription: "ونش انقاذ الألف مسكن: ميدان الألف مسكن، محطة مترو الألف مسكن، شارع جسر السويس، شارع عبد العزيز فهمي. وصول 5-10 دقائق - 01044844492.",
    intro: "ميدان الألف مسكن المركز التجاري والملتقى الحيوي بين مصر الجديدة وعين شمس وجسر السويس. نوفر أوناش إنقاذ متمركزة بالميدان لسرعة نجدة أي سيارة متعطلة في دقائق معدودة.",
    responseTime: "5–10 دقائق في الألف مسكن",
    landmarks: ["ميدان الألف مسكن الشهير", "محطة مترو الألف مسكن (الخط الثالث)", "موقف ميكروباص الألف مسكن", "نادي الشمس (البوابة الخلفية)", "سوق الألف مسكن التجاري"],
    streets: ["شارع جسر السويس", "شارع عبد العزيز فهمي", "شارع فريد سميكة", "شارع أحمد مخيمر", "شارع محطة الجراج"],
    localNotes: ["تمركز فوري عند مخرج محطة مترو الألف مسكن وميدان الألف مسكن لضمان أسرع استجابة.", "سحب آمن وسريع للمركبات ونقلها لورش الحرفيين أو مصر الجديدة."],
    faqs: [
      {
            "q": "هل يتوفر ونش عند ميدان ومحطة مترو الألف مسكن؟",
            "a": "نعم، أوناشنا متواجدة بميدان الألف مسكن على مدار 24 ساعة."
      }
,
      {
        "q": "كيف تصلون بسرعة لحي ألف مسكن وسط الشوارع الداخلية؟",
        "a": "نستخدم مداخل محور عين شمس وشارع زكريا أحمد لتجنب الضغط على الخطوط الرئيسية."
      }],
    nearby: ["جسر السويس", "عين شمس", "مصر الجديدة", "النزهة", "حلمية الزيتون"]
  },

  "الحرفيين": {
    tier: 2,
    title: "ونش انقاذ الحرفيين",
    metaDescription: "ونش انقاذ الحرفيين: مجمع ورش وصيانة السيارات، شارع جمال عبد الناصر، شارع 27، كوبري الحرفيين. وصول 10 دقائق خدمة 24/7 - 01044844492.",
    intro: "ونش إنقاذ الحرفيين بقلب عاصمة صيانة وقطع غيار السيارات؛ نصلك في دقائق معدودة لنقل سيارتك المعطلة أو المتضررة من الحوادث إلى أي ورشة أو مركز صيانة تختاره.",
    responseTime: "10 دقائق في الحرفيين",
    landmarks: ["مجمع ورش ومراكز صيانة الحرفيين", "كوبري الحرفيين العلوي", "سوق قطع غيار الحرفيين", "محطة بنزين وطنية الحرفيين", "مبنى حي السلام أول"],
    streets: ["شارع جمال عبد الناصر (الحرفيين)", "شارع 27 الحرفيين", "شارع المعهد الديني", "شارع الخمسين الحرفيين", "طريق كوبري الحرفيين"],
    localNotes: ["معرفة تامة بكافة ورش الميكانيكا والسمكرة والدوكو وتعديل السيارات ومحلات قطع الغيار بالحرفيين.", "أوناش مدمجة تستطيع المناورة والالتفاف داخل شوارع الحرفيين المزدحمة بقطع الغيار والسيارات المركونة.", "مساعدة العميل في إنزال السيارة داخل الورشة المطلوبة دون أي عناء."],
    faqs: [
      {
            "q": "هل تنقلون السيارات المتعطلة من أي مكان بالقاهرة مباشرة إلى ورش الحرفيين؟",
            "a": "نعم، ننقل يومياً عشرات السيارات إلى الحرفيين من التجمع ومدينة نصر ومصر الجديدة والدائري."
      },
      {
            "q": "كم يستغرق الوصول لو تعطلت سيارتي داخل شوارع الحرفيين؟",
            "a": "نصلك في أقل من 10 دقائق لتواجد أوناشنا الدائم داخل منطقة الحرفيين وجسر السويس."
      }
],
    nearby: ["جسر السويس", "النزهة الجديدة", "مدينة السلام", "الهايكستب", "عين شمس"]
  },

  "مدينة السلام": {
    tier: 2,
    title: "ونش انقاذ مدينة السلام",
    metaDescription: "ونش انقاذ مدينة السلام: موقف العاشر الجديد، طريق الإسماعيلية، شارع السادات، سوق العبد، إسكان الشباب. وصول 10-15 دقيقة - 01044844492.",
    intro: "ونش إنقاذ مدينة السلام ومحيط موقف العاشر الجديد وطريق الإسماعيلية والنزهة 2؛ استجابة سريعة على مدار 24 ساعة لخدمة سيارات الملاكي والميكروباص والنقل.",
    responseTime: "10–15 دقيقة في مدينة السلام",
    landmarks: ["موقف السلام الإقليمي الجديد", "محطة عدلي منصور التبادلية", "مستشفى السلام التخصصي", "سوق العبد التجاري بالسلام", "ميدان السادات السلام"],
    streets: ["طريق القاهرة - الإسماعيلية الصحراوي", "شارع السادات", "شارع الترعة الإسماعيلية", "شارع أحمد عرابي السلام"],
    localNotes: ["تمركز مباشر عند تقاطع الدائري مع طريق الإسماعيلية وموقف السلام الإقليمي.", "أوناش سحب قوية قادرة على التعامل مع سيارات الملاكي وسيارات النقل الخفيف والميكروباص.", "تأمين موقع السيارة في المناطق ذات الكثافة المرورية العالية بمحيط موقف السلام."],
    faqs: [
      {
            "q": "هل الونش متاح بالقرب من موقف العاشر الجديد بمدينة السلام؟",
            "a": "نعم، لدينا نقطة ارتكاز دائمة بمحيط موقف العاشر ومطلع الدائري للوصول في دقائق."
      },
      {
            "q": "لو الكاوتش نايم في السلام هل يتوفر تغيير عجل؟",
            "a": "نعم، نوفر خدمة تغيير إطارات وتزويد هواء ووصلة بطارية في الموقع فوراً."
      }
],
    nearby: ["الهايكستب", "جسر السويس", "الحرفيين", "طريق الإسماعيلية", "العبور", "الدائري"]
  },

  "وسط البلد": {
    tier: 1,
    title: "ونش انقاذ وسط البلد التحرير ورمسيس",
    metaDescription: "ونش انقاذ وسط البلد: ميدان التحرير، طلعت حرب، قصر النيل، رمسيس، عبد المنعم رياض، عابدين. وصول 10 دقائق خدمة 24/7 بخصم 50% - اتصل 01044844492.",
    intro: "وسط البلد قلب العاصمة التاريخي ومركز المؤسسات الكبرى. نوفر أوناش إنقاذ مدمجة وحديثة متمركزة في ميدان التحرير وميدان طلعت حرب وعبد المنعم رياض للتدخل السريع وإنقاذ السيارات في شوارع وسط البلد المزدحمة.",
    responseTime: "10 دقائق في وسط البلد",
    landmarks: ["ميدان التحرير والمتحف المصري", "ميدان طلعت حرب", "ميدان عبد المنعم رياض", "ميدان رمسيس ومحطة مصر", "قصر عابدين", "ميدان الفلكي وميدان الأوبرا"],
    streets: ["شارع طلعت حرب", "شارع قصر النيل", "شارع رمسيس", "شارع التحرير", "شارع محمد محمود", "شارع 26 يوليو (وسط البلد)", "شارع شريف"],
    localNotes: ["أوناش مدمجة متخصصة للمناورة في الشوارع التراثية والأزقة التجارية بوسط البلد.", "تأمين فوري للسيارات في مواقف التحرير وعابدين والأوبرا وكورنيش النيل ماسبيرو."],
    faqs: [
      {
            "q": "كم يستغرق وصول ونش الإنقاذ في ميدان التحرير أو شارع طلعت حرب؟",
            "a": "يصل الونش خلال أقل من 10 دقائق لتواجد سياراتنا الدائم بميدان التحرير وعبد المنعم رياض."
      }
,
      {
        "q": "هل تستطيعون سحب سيارة من داخل حي التحرير أو وسط البلد أثناء الزحام الشديد؟",
        "a": "نعم، لدينا أوناش مدمجة صغيرة تخترق ضغط الحركة في وسط البلد والعتبة وميدان التحرير."
      }],
    nearby: ["رمسيس", "ميدان الإسعاف", "العتبة", "الموسكي", "السيدة زينب", "الزمالك", "الدقي"]
  },

  "رمسيس": {
    tier: 1,
    title: "ونش انقاذ رمسيس ومحطة مصر",
    metaDescription: "ونش انقاذ رمسيس: ميدان رمسيس، محطة مصر، كوبري 6 أكتوبر، شارع رمسيس، الفجالة، كوبري الليمون. وصول 5-10 دقائق - 01044844492.",
    intro: "ميدان رمسيس أكبر ملتقى مروري وسككي في جمهورية مصر العربية. أوناش إنقاذ محمد بحر متمركزة عند ميدان رمسيس ومطالع ومنازل كوبري 6 أكتوبر لإنقاذ وإخلاء فوري لأي سيارة متعطلة لمنع الشلل المروري.",
    responseTime: "5–10 دقائق في رمسيس",
    landmarks: ["ميدان رمسيس الشهير", "محطة مصر للقطارات", "مسجد الفتح برمسيس", "مجمع محاكم شمال القاهرة", "ميدان الإسعاف برمسيس", "شارع الفجالة التجاري"],
    streets: ["شارع رمسيس الرئيسي", "شارع الجلاء", "شارع الجمهورية", "شارع كلوت بك", "شارع أحمد حلمي", "كوبري 6 أكتوبر (قطاع رمسيس)"],
    localNotes: ["أوناش مجهزة للتعامل مع أعطال وحوادث كوبري 6 أكتوبر وميدان رمسيس بأقصى سرعة.", "تأمين الحوادث وسحب السيارات دون إعاقة حركة حافلات السفر والترام والمترو."],
    faqs: [
      {
            "q": "هل يتوفر ونش إنقاذ أعلى كوبري 6 أكتوبر قطاع رمسيس؟",
            "a": "نعم، أوناشنا متواجدة بمحيط كوبري 6 أكتوبر عند منزل ومطلع رمسيس على مدار 24 ساعة."
      }
,
      {
        "q": "هل تخدمون ميدان رمسيس ومحطة القطارات والشوارع المحيطة بها؟",
        "a": "نعم، ميدان رمسيس ومحطة مصر وكل الشوارع المتفرعة في الباب الشعرية والشلالات مغطاة."
      }],
    nearby: ["وسط البلد", "ميدان الإسعاف", "العتبة", "الفجالة", "غمرة", "شبرا مصر"]
  },

  "ميدان الإسعاف": {
    tier: 2,
    title: "ونش انقاذ ميدان الإسعاف وسط البلد",
    metaDescription: "ونش انقاذ ميدان الإسعاف: شارع 26 يوليو، شارع رمسيس، محطة مترو جمال عبد الناصر، دار القضاء العالي. وصول 5-10 دقائق - 01044844492.",
    intro: "ميدان الإسعاف هو نقطة التقاء شارع رمسيس مع شارع 26 يوليو وشارع الجلاء. نوفر أوناش إنقاذ متواجدة بالميدان لخدمة محيط دار القضاء العالي ونقابة المحامين ومترو ناصر طوال 24 ساعة.",
    responseTime: "5–10 دقائق في ميدان الإسعاف",
    landmarks: ["مبنى هيئة الإسعاف المصرية التاريخي", "دار القضاء العالي", "محطة مترو جمال عبد الناصر التبادلية", "مبنى نقابة الصحفيين والمحامين", "معهد ناصر للبحوث (بالقرب)"],
    streets: ["شارع رمسيس", "شارع 26 يوليو", "شارع الجلاء", "شارع عبد الخالق ثروت", "شارع شامبليون"],
    localNotes: ["تمركز فوري عند مخرج محطة مترو ناصر لسرعة التحرك نحو وسط البلد أو رمسيس أو الزمالك.", "أوناش مدمجة تتفادى الزحام وتصل للعميل بأقصر الطرق."],
    faqs: [
      {
            "q": "كم يستغرق وصول ونش الإنقاذ أمام دار القضاء العالي أو ميدان الإسعاف؟",
            "a": "أقل من 10 دقائق لتواجدنا الدائم بميدان الإسعاف."
      }
,
      {
        "q": "كيف يمكن للونش الوصول في ميدان الإسعاف وسط ضغط المرور؟",
        "a": "لدينا طرق بديلة عبر رمسيس والكورنيش لتجاوز ميدان الإسعاف — وصولنا مضمون في 10-20 دقيقة."
      }],
    nearby: ["وسط البلد", "رمسيس", "العتبة", "الزمالك", "ماسبيرو"]
  },

  "العتبة": {
    tier: 2,
    title: "ونش انقاذ العتبة",
    metaDescription: "ونش انقاذ العتبة: ميدان العتبة، شارع الأزهر، الموسكي، جراج العتبة، المسرح القومي، شارع عبد العزيز. وصول 10 دقائق - 01044844492.",
    intro: "ميدان العتبة أكبر مركز تجاري تاريخي للأسواق الشعبية والأجهزة الإلكترونية. نوفر أوناش إنقاذ مخصصة للتحرك بمرونة في محيط جراج العتبة المتعدد الطوابق، شارع عبد العزيز، ومداخل نفق الأزهر.",
    responseTime: "10 دقائق في العتبة",
    landmarks: ["ميدان العتبة التجاري", "جراج العتبة المتعدد الطوابق", "المسرح القومي ومسرح الطليعة", "شارع عبد العزيز للأجهزة الكهربائية", "محطة مترو العتبة التبادلية"],
    streets: ["شارع الأزهر", "شارع عبد العزيز", "شارع الجيش", "شارع الجمهورية", "شارع القلعة (محمد علي)", "شارع الموسكي"],
    localNotes: ["أوناش مدمجة للتعامل مع الشوارع التجارية المزدحمة وسحب السيارات بكفاءة وأمان.", "تأمين فوري لمداخل ومخارج نفق الأزهر ومحيط المسرح القومي."],
    faqs: [
      {
            "q": "هل يستطيع الونش سحب سيارة معطلة داخل جراج العتبة أو شارع عبد العزيز؟",
            "a": "نعم، نوفر أوناشاً مخصصة للتعامل مع جراجات ومناطق العتبة التجارية."
      }
,
      {
        "q": "هل تخدمون منطقة خان الخليلي والعتبة والشوارع التجارية المزدحمة؟",
        "a": "نعم، لدينا أوناش صغيرة مناسبة للشوارع الضيقة في العتبة والموسكي والمحيط التجاري بأكمله."
      }],
    nearby: ["الموسكي", "وسط البلد", "رمسيس", "باب الشعرية", "الأزهر", "السيدة زينب"]
  },

  "الموسكي": {
    tier: 2,
    title: "ونش انقاذ الموسكي والأزهر",
    metaDescription: "ونش انقاذ الموسكي: شارع المعز، خان الخليلي، الحسين، نفق الأزهر، شارع الجيش. وصول 10-15 دقيقة خدمة 24 ساعة - 01044844492.",
    intro: "منطقة الموسكي وخان الخليلي التاريخية في قلب القاهرة الفاطمية. نوفر أوناش سحب سيارات مجهزة للوصول إلى محيط الحسين وشارع المعز ومداخل نفق الأزهر لنقل السيارات المعطلة بأرخص تكلفة.",
    responseTime: "10–15 دقيقة في الموسكي",
    landmarks: ["مسجد الإمام الحسين", "خان الخليلي وشارع المعز", "جامع الأزهر الشريف", "مستشفى الحسين الجامعي", "نفق الأزهر الرابط مع صلاح سالم"],
    streets: ["شارع الأزهر", "شارع المعز لدين الله الفاطمي", "شارع بورسعيد (الموسكي)", "شارع جوهر القائد", "طريق صلاح سالم (مدخل الحسين)"],
    localNotes: ["تأمين الحوادث والأعطال السريعة داخل نفق الأزهر وعلى مخارجه باتجاه صلاح سالم.", "أوناش مجهزة للتعامل مع الشوارع التاريخية والمزدحمة بأمان كامل."],
    faqs: [
      {
            "q": "هل يتوفر ونش إنقاذ داخل أو بالقرب من نفق الأزهر بالحسين؟",
            "a": "نعم، أوناشنا متمركزة عند مدخل ومخرج نفق الأزهر على مدار 24 ساعة."
      }
,
      {
        "q": "هل تخدمون الشوارع الضيقة في الموسكي وخان الخليلي؟",
        "a": "نعم، الموسكي والغورية وشارع الأزهر والحسين مغطاة بأوناش مدمجة خاصة بالشوارع الضيقة."
      }],
    nearby: ["العتبة", "باب الشعرية", "وسط البلد", "صلاح سالم", "الدراسة", "الجمالية"]
  },

  "باب الشعرية": {
    tier: 2,
    title: "ونش انقاذ باب الشعرية",
    metaDescription: "ونش انقاذ باب الشعرية: ميدان باب الشعرية، محطة المترو، شارع الجيش، كلوت بك، شارع بورسعيد. وصول 10 دقائق خدمة 24/7 - 01044844492.",
    intro: "خدمة ونش إنقاذ سيارات متواجدة على مدار 24 ساعة في حي باب الشعرية، نغطي ميدان باب الشعرية، شارع الجيش، محطة مترو باب الشعرية، ومحيط الفجالة والظاهر بأفضل الأسعار.",
    responseTime: "10 دقائق في باب الشعرية",
    landmarks: ["ميدان باب الشعرية ومحطة المترو", "شارع الجيش التجاري", "مستشفى باب الشعرية الجامعي (سيد جلال)", "ميدان الظاهر بيبرس", "شارع كلوت بك"],
    streets: ["شارع الجيش", "شارع بورسعيد", "شارع كلوت بك", "شارع باب البحر", "شارع سكة الظاهر"],
    localNotes: ["أوناش مدمجة تتنقل بمرونة في شوارع باب الشعرية والظاهر وتصل للعميل بأمان.", "توفير خدمات وصلة بطارية وتغيير إطارات وسحب آمن للمركبات."],
    faqs: [
      {
            "q": "كم يستغرق وصول ونش الإنقاذ في ميدان باب الشعرية أو أمام مستشفى سيد جلال؟",
            "a": "يصل الونش خلال أقل من 10 دقائق لتواجدنا الدائم بميدان باب الشعرية."
      }
,
      {
        "q": "هل تغطون منطقة باب الشعرية والشوارع الداخلية المحيطة بها؟",
        "a": "نعم، باب الشعرية وشارع أحمد عرابي وصولاً لميدان رمسيس والعباسية مغطاة بأوناشنا."
      }],
    nearby: ["العتبة", "الموسكي", "رمسيس", "الظاهر", "الفجالة", "العباسية"]
  },

  "السيدة زينب": {
    tier: 1,
    title: "ونش انقاذ السيدة زينب",
    metaDescription: "ونش انقاذ السيدة زينب: ميدان السيدة، شارع بورسعيد، مستشفى قصر العيني، شارع مجلس الأمة، المنيرة. وصول 10 دقائق بخصم 50% - 01044844492.",
    intro: "حي السيدة زينب قلب القاهرة الشعبية والتاريخية. أوناش إنقاذ محمد بحر متمركزة بميدان السيدة ومحيط مستشفى قصر العيني والمنيرة ومجلس الشعب لإنقاذ وسحب سيارات الملاكي والأجرة طوال 24 ساعة.",
    responseTime: "10 دقائق في السيدة زينب",
    landmarks: ["مسجد السيدة زينب وميدان السيدة", "مستشفى قصر العيني الفرنساوي والقديم", "مستشفى المنيرة العام", "مبنى مجلس النواب والوزراء", "محطة مترو السيدة زينب ومحطة سعد زغلول"],
    streets: ["شارع بورسعيد (السيدة زينب)", "شارع قصر العيني", "شارع مجلس الأمة", "شارع خيرت", "شارع نوبار", "شارع السد البراني"],
    localNotes: ["تغطية فورية لحالات الطوارئ بمحيط مجمع مستشفيات قصر العيني والمنيرة.", "أوناش مدمجة للتعامل مع الشوارع التاريخية والمزدحمة بحي السيدة زينب."],
    faqs: [
      {
            "q": "كم يستغرق وصول ونش الإنقاذ أمام مستشفى قصر العيني أو ميدان السيدة زينب؟",
            "a": "أقل من 10 دقائق لتواجد سياراتنا المستمر عند شارع قصر العيني وميدان السيدة."
      }
,
      {
        "q": "هل تخدمون ميدان السيدة زينب ومسجدها الشهير وشوارع المنطقة؟",
        "a": "نعم، ميدان السيدة زينب وشارع محمد علي والقلعة والمنيرة مغطاة 24 ساعة."
      }],
    nearby: ["المنيرة", "وسط البلد", "القلعة", "السيدة عائشة", "مصر القديمة", "المنيل"]
  },

  "المنيرة": {
    tier: 2,
    title: "ونش انقاذ المنيرة وقصر العيني",
    metaDescription: "ونش انقاذ المنيرة: مستشفى المنيرة، شارع نوبار، شارع مجلس النواب، شارع الفلكي، كوبري قصر النيل. وصول 5-10 دقائق - 01044844492.",
    intro: "منطقة المنيرة الرابطة بين السيدة زينب وجاردن سيتي ووسط البلد. نوفر أوناش إنقاذ متمركزة لخدمة محيط المستشفيات والوزارات والمدارس على مدار 24 ساعة بأسرع وقت وأرخص سعر.",
    responseTime: "5–10 دقائق في المنيرة",
    landmarks: ["مستشفى المنيرة العام", "المركز الثقافي الفرنسي بالمنيرة", "محطة مترو سعد زغلول", "ميدان لاظوغلي ووزارة العدل", "مجمع مدارس المنيرة"],
    streets: ["شارع نوبار", "شارع الفلكي", "شارع الشيخ ريحان", "شارع قصر العيني", "شارع إسماعيل سري"],
    localNotes: ["أوناش سريعة ومدمجة للتحرك في شوارع المنيرة وجاردن سيتي الهادئة.", "توفير خدمات الطوارئ للبطاريات وتزويد البنزين وتغيير الإطارات في الموقع."],
    faqs: [
      {
            "q": "هل تغطون محيط وزارة العدل وميدان لاظوغلي ومستشفى المنيرة؟",
            "a": "نعم، أوناشنا متواجدة على مدار 24 ساعة بمحيط المنيرة ولاظوغلي."
      }
,
      {
        "q": "هل تغطون منطقة المنيرة ومنيل الروضة وشارع كورنيش النيل؟",
        "a": "نعم، المنيرة ومنيل الروضة وجزيرة بدران وكورنيش المنيرة مغطاة بخدمتنا الكاملة."
      }],
    nearby: ["السيدة زينب", "وسط البلد", "جاردن سيتي", "قصر العيني", "التحرير"]
  },

  "القلعة": {
    tier: 2,
    title: "ونش انقاذ القلعة وصلاح الدين",
    metaDescription: "ونش انقاذ القلعة: قلعة صلاح الدين، ميدان القلعة، مسجد السلطان حسن والرفاعي، طريق صلاح سالم. وصول 10 دقائق - 01044844492.",
    intro: "منطقة قلعة صلاح الدين الأيوبي التاريخية ومحيط مسجدي السلطان حسن والرفاعي. أوناشنا متمركزة بميدان القلعة وعلى طريق صلاح سالم لتقديم خدمات إنقاذ وسحب سيارات فورية وآمنة طوال 24 ساعة.",
    responseTime: "10 دقائق في القلعة",
    landmarks: ["قلعة صلاح الدين الأيوبي", "جامع محمد علي بالقلعة", "مسجد السلطان حسن ومسجد الرفاعي", "ميدان القلعة (ميدان صلاح الدين)", "متحف الشرطة والمتحف الحربي"],
    streets: ["طريق صلاح سالم", "شارع القلعة (محمد علي)", "شارع سكة المحجر", "محور جيهان السادات (مخرج القلعة)", "شارع الإمام الشافعي"],
    localNotes: ["تأمين سيارات الأفواج السياحية والزوار في مواقف القلعة ومحيط المساجد الأثرية.", "جاهزية للتعامل مع منحدرات ومطالع هضبة القلعة وطريق صلاح سالم بأمان تام."],
    faqs: [
      {
            "q": "هل يتوفر ونش إنقاذ عند مواقف قلعة صلاح الدين أو مسجد الرفاعي؟",
            "a": "نعم، أوناشنا متواجدة بميدان القلعة وصلاح سالم وتصلك في دقائق معدودة."
      }
,
      {
        "q": "هل تخدمون منطقة القلعة وسوق السيارات المجاور لها؟",
        "a": "نعم، القلعة والمنطقة المحيطة بها بما في ذلك شارع صلاح الدين والسيدة عائشة مغطاة كاملاً."
      }],
    nearby: ["السيدة عائشة", "السيدة زينب", "صلاح سالم", "المقطم", "محور جيهان السادات"]
  },

  "السيدة عائشة": {
    tier: 2,
    title: "ونش انقاذ السيدة عائشة",
    metaDescription: "ونش انقاذ السيدة عائشة: ميدان السيدة عائشة، كوبري السيدة عائشة، صلاح سالم، الأوتوستراد، سوق الحمام. وصول 5-10 دقائق - 01044844492.",
    intro: "ميدان السيدة عائشة ملتقى حيوي يربط بين طريق صلاح سالم والأوتوستراد والقلعة ومصر القديمة. نوفر أوناش إنقاذ متمركزة أسفل كوبري السيدة عائشة لسرعة إخلاء الأعطال والحوادث فوراً.",
    responseTime: "5–10 دقائق في السيدة عائشة",
    landmarks: ["مسجد السيدة عائشة وميدان السيدة عائشة", "كوبري السيدة عائشة العلوي", "موقف سيارات السيدة عائشة", "سوق الحمام وسوق الجمعة الشهير", "مقابر الإمام الشافعي"],
    streets: ["طريق صلاح سالم", "طريق الأوتوستراد", "شارع القلعة", "شارع الإمام الشافعي", "شارع مجرى العيون"],
    localNotes: ["أوناش متواجدة أسفل كوبري السيدة عائشة لإنقاذ فوري لحوادث وأعطال الكوبري ومطالعه.", "سحب آمن وسريع للمركبات ونقلها لأي موقع في القاهرة أو الجيزة."],
    faqs: [
      {
            "q": "كم يستغرق وصول ونش الإنقاذ عند كوبري أو ميدان السيدة عائشة؟",
            "a": "يصل الونش خلال أقل من 10 دقائق لتمركزنا المباشر بالميدان."
      }
,
      {
        "q": "هل تخدمون حي السيدة عائشة والمنطقة الواقعة بين القلعة والمعادي؟",
        "a": "نعم، السيدة عائشة وطرة وحلوان الجديدة مغطاة، ونصل في 10-20 دقيقة عبر طريق الكورنيش."
      }],
    nearby: ["القلعة", "السيدة زينب", "صلاح سالم", "الأوتوستراد", "البساتين", "مصر القديمة"]
  },

  "شبرا": {
    tier: 1,
    title: "ونش انقاذ شبرا",
    metaDescription: "ونش انقاذ شبرا: شارع شبرا الرئيسي، روض الفرج، الخلفاوي، الساحل، دوران شبرا، كوبري أحمد حلمي. وصول 10 دقائق خدمة 24/7 - 01044844492.",
    intro: "أسرع ونش إنقاذ في شبرا مصر: دوران شبرا، شارع شبرا الرئيسي، روض الفرج، أحمد بدوي، وخلوصي؛ أوناش شوكة وسحب مدمجة تصلك خلال 10 دقائق.",
    responseTime: "10 دقائق في شبرا",
    landmarks: ["دوران شبرا ومحطة مترو روض الفرج", "محطة مترو الخلفاوي وسانت تريزا", "مستشفى معهد ناصر بكورنيش النيل", "مستشفى الساحل التعليمي", "كوبري أحمد حلمي وموقف عبود", "ميدان المماليك"],
    streets: ["شارع شبرا الرئيسي", "شارع الترعة البولاقية", "شارع خلوصي التجاري", "شارع أحمد حلمي", "شارع كورنيش النيل (شبرا والساحل)", "شارع جزيرة بدران"],
    localNotes: ["أوناش شوكة مدمجة فائقة المناورة للالتفاف في أزقة وشوارع شبرا السكنية الضيقة دون شل حركة السير.", "إخلاء سريع للسيارات المعطلة على امتداد خط مترو شبرا لتجنب التكدسات والمخالفات المرورية.", "قرب المسافة لنقل السيارة لورش الساحل ومسطرد أو مجمعات صيانة شبرا الخيمة والحرفيين."],
    faqs: [
      {
            "q": "هل يستطيع الونش الدخول في حارات وشوارع شبرا الضيقة؟",
            "a": "نعم، نعتمد في شبرا على أوناش شوكة مدمجة (Wheel-Lift) مصممة خصيصاً للمساحات الضيقة والأزقة السكنية."
      },
      {
            "q": "هل تقدمون وصلة بطارية في شبرا لو العربية مش بتدور؟",
            "a": "نعم، نوفر أجهزة شحن طوارئ سريعة وميكانيكي متنقل في شبرا لحل المشكلة في مكانك."
      }
],
    nearby: ["روض الفرج", "الساحل", "شبرا الخيمة", "رمسيس", "موقف عبود", "الوراق"]
  },

  "غمرة": {
    tier: 2,
    title: "ونش انقاذ غمرة والظاهر",
    metaDescription: "ونش انقاذ غمرة: محطة مترو غمرة، كوبري غمرة العلوي، شارع رمسيس، مستشفى القبطي، الظاهر. وصول 5-10 دقائق - 01044844492.",
    intro: "منطقة غمرة والظاهر قلب الوصل بين رمسيس والعباسية ومصر الجديدة. نوفر أوناش إنقاذ متمركزة بجوار كوبري غمرة ومحطة المترو والمستشفى القبطي لإنقاذ سريع ومحترف على مدار 24 ساعة.",
    responseTime: "5–10 دقائق في غمرة",
    landmarks: ["محطة مترو غمرة", "كوبري غمرة العلوي", "المستشفى القبطي بشارع رمسيس", "ميدان الظاهر بيبرس", "مستشفى غمرة العسكري"],
    streets: ["شارع رمسيس (قطاع غمرة)", "شارع بور سعيد", "شارع أحمد سعيد", "شارع سكة الوايلي", "شارع الفجالة (امتداد غمرة)"],
    localNotes: ["أوناش متواجدة عند مطلع كوبري غمرة ومحور أحمد سعيد لسرعة الحركة.", "توفير خدمات الطوارئ للبطاريات وتغيير الإطارات وتزويد الوقود في الموقع."],
    faqs: [
      {
            "q": "هل يتوفر ونش عند كوبري غمرة ومحطة المترو بشارع رمسيس؟",
            "a": "نعم، أوناشنا متواجدة بغمرة على مدار 24 ساعة وتصلك في غضون 5 إلى 10 دقائق."
      }
,
      {
        "q": "هل تخدمون ميدان غمرة وشارع أحمد سعيد المتفرع منه؟",
        "a": "نعم، ميدان غمرة وشارع أحمد سعيد والشوارع المتفرعة نحو العباسية والنزهة مغطاة كاملاً."
      }],
    nearby: ["رمسيس", "العباسية", "الظاهر", "باب الشعرية", "الفجالة", "حدائق القبة"]
  },

  "الطريق الدائري": {
    tier: 1,
    title: "ونش انقاذ الطريق الدائري",
    metaDescription: "ونش انقاذ الطريق الدائري: تغطية 24/7 لكافة قطاعات ومخارج الدائري، الكوبري المعلق على النيل، وصلة المريوطية، ومحور 26 يوليو. وصول 10-15 دقيقة - 01044844492.",
    intro: "ونش إنقاذ الطريق الدائري الأسرع والأوسع انتشاراً حول القاهرة الكبرى (100 كم)؛ تمركزات على كافة المطالع والمنازل لنجدتك في أقل من 15 دقيقة على مدار 24 ساعة.",
    responseTime: "10–15 دقيقة على الطريق الدائري",
    landmarks: ["كوبري المنيب المعلق", "تقاطع الدائري مع الأوتوستراد (صقر قريش)", "نزلة المريوطية واللبيني", "تقاطع الدائري مع محور 26 يوليو", "نزلة مسطرد وشبرا بنها الحر", "تقاطع الدائري مع طريق السويس والإسماعيلية"],
    streets: ["الطريق الدائري حول القاهرة الكبرى", "الدائري الأوسطي", "الدائري الإقليمي", "محور 26 يوليو", "طريق الأوتوستراد"],
    localNotes: ["أولوية قصوى لتأمين مسار السيارة المتعطلة بحواجز وإشارات فوسفورية لمنع حوادث الاصطدام الخلفي على سرعات الدائري.", "تغطية كاملة للقطاعات الحرجة: وصلة المريوطية، المنيب، القوس الغربي، باسوس، بهتيم، السلام، والتجمع.", "أوناش سطحة سريعة وأوناش انتشال للتعامل مع كافة حالات الأعطال والحوادث وانقلاب المركبات."],
    faqs: [
      {
            "q": "ما أول شيء أفعله لو تعطلت سيارتي فجأة على الطريق الدائري؟",
            "a": "انحز فوراً لحارة الطوارئ اليمنى، وشغل الفلاشر، وضع مثلث التحذير، وقف خلف الحاجز الخرساني ثم اتصل بنا فوراً على 01044844492."
      },
      {
            "q": "كم دقيقة يستغرق ونش الدائري للوصول؟",
            "a": "متوسط وقت الوصول من 10 إلى 15 دقيقة بفضل توزيع سياراتنا بالقرب من أهم منازل ومطالع الدائري."
      }
],
    nearby: ["المعادي", "المنيب", "المريوطية", "التجمع الخامس", "السلام", "الوراق", "محور 26 يوليو"]
  },

  "طريق السويس": {
    tier: 1,
    title: "ونش انقاذ طريق السويس الصحراوي",
    metaDescription: "ونش انقاذ طريق السويس: من كوبري ألماظة ومصر الجديدة حتى التجمع، الرحاب، مدينتي، الشروق، بدر، الكيلو 109 والسويس. وصول 15 دقيقة - 01044844492.",
    intro: "طريق القاهرة - السويس الصحراوي محور التنمية السريع الرابط بين القاهرة ومدن القناة والعاصمة الإدارية. نوفر أوناش إنقاذ سريعة متمركزة عند بوابات الرسوم ومدخل الرحاب ومدينتي والشروق وبدر لإنقاذ فوري على مدار 24 ساعة.",
    responseTime: "15 دقيقة على طريق السويس",
    landmarks: ["بوابة رسوم طريق السويس (كارتة السويس)", "مدخل مدينة الرحاب ومدينتي", "مدخل مدينة الشروق وبدر", "تقاطع الدائري الأوسطي والإقليمي", "نادي وادي دجلة النخيل", "محطة وطنية الكيلو 4.5"],
    streets: ["طريق القاهرة - السويس الصحراوي الحر", "محور الأمل", "الدائري الأوسطي", "الدائري الإقليمي", "طريق جنيفة"],
    localNotes: ["أوناش سريعة وقوية قادرة على الوصول لمسافات طويلة على طريق السويس حتى الكيلو 109 والسويس.", "تأمين شامل للمركبات المتعطلة على الحارات السريعة وتوفير خدمات بنزين وإطارات وشحن بطاريات."],
    faqs: [
      {
            "q": "هل تغطون طريق السويس بالكامل حتى بوابات العاصمة الإدارية والسويس؟",
            "a": "نعم، نغطي طريق السويس من ألماظة ومصر الجديدة حتى بوابات السويس والعين السخنة على مدار الساعة."
      }
,
      {
        "q": "ما أسرع زمن وصول على طريق السويس من مدخل القاهرة حتى العاشر من رمضان؟",
        "a": "على الطريق السريع نصل في 15-25 دقيقة. لدينا نقطة تمركز عند مدخل الشروق على طريق السويس."
      }],
    nearby: ["الرحاب", "مدينتي", "الشروق", "بدر", "العاصمة الإدارية", "السويس", "طريق السخنة"]
  },

  "طريق العين السخنة": {
    tier: 1,
    title: "ونش انقاذ طريق العين السخنة",
    metaDescription: "ونش انقاذ طريق العين السخنة: من بوابات القطامية والمعادي حتى بوابات السخنة، بورتو السخنة، الجلالة، والزعفرانة. وصول 15-20 دقيقة - 01044844492.",
    intro: "طريق القاهرة - العين السخنة الحر شريان السياحة والاستثمار على البحر الأحمر. ننشر أوناش إنقاذ متخصصة متمركزة عند كارتة القطامية ومخرج العاصمة الإدارية ومحطات الوقود لإنقاذ فوري لحالات الأعطال والحوادث على مدار 24 ساعة.",
    responseTime: "15–20 دقيقة على طريق السخنة",
    landmarks: ["بوابة رسوم طريق السخنة (كارتة القطامية)", "محطة وقود شل أوت الكيلو 40", "تقاطع الدائري الإقليمي مع طريق السخنة", "مدخل العاصمة الإدارية الجنوبي", "بوابة العين السخنة", "منتجع بورتو السخنة وجبل الجلالة"],
    streets: ["طريق القاهرة - العين السخنة الحر", "طريق الجلالة الجديد", "طريق الزعفرانة الساحلي", "الدائري الإقليمي", "محور 30 يونيو"],
    localNotes: ["أوناش سطحة هيدروليكية طويلة المسافات مجهزة لنقل السيارات من السخنة إلى القاهرة أو العكس بأمان تام.", "جاهزية لنقل الركاب والسيارات في حالات الأعطال المفاجئة في المناطق الصحراوية والجبلية."],
    faqs: [
      {
            "q": "كم يستغرق وصول ونش الإنقاذ على طريق السخنة عند الكيلو 40 أو كارتة الرسوم؟",
            "a": "من 15 إلى 20 دقيقة فقط لتمركز أوناشنا الدائم بالقرب من محطات الوقود وكارتة القطامية."
      }
,
      {
        "q": "هل تغطون الطريق بين القاهرة والسخنة في حالات الأعطال الليلية؟",
        "a": "نعم، طريق العين السخنة مغطى 24 ساعة من مدخل القاهرة حتى أبواب العين السخنة."
      }],
    nearby: ["العين السخنة", "بورتو السخنة", "القطامية", "العاصمة الإدارية", "طريق السويس", "الزعفرانة"]
  },

  "العين السخنة": {
    tier: 1,
    title: "ونش انقاذ العين السخنة",
    metaDescription: "ونش انقاذ العين السخنة: بورتو السخنة، هضبة الجلالة، مارينا وادي دوم، ستيلا دي ماري، الزعفرانة. وصول 15-20 دقيقة خدمة 24/7 بخصم 50% - 01044844492.",
    intro: "العين السخنة الوجهة الشاطئية الأولى للبحر الأحمر لقاطني القاهرة والقناة. نوفر أوناش إنقاذ متمركزة في قلب منتجعات السخنة وبورتو والجلالة لتقديم خدمة سحب ورفع سيارات سريعة وموثوقة على مدار الساعة.",
    responseTime: "15–20 دقيقة في العين السخنة",
    landmarks: ["منتجع بورتو السخنة Porto Sokhna", "مدينة ومنتجع الجلالة العالمي", "قرية ستيلا دي ماري Stella Di Mare", "مارينا وادي دوم", "فندق موفنبيك السخنة", "ميناء السخنة ومحطة الحاويات"],
    streets: ["طريق السويس - العين السخنة الساحلي", "طريق الجلالة", "طريق الزعفرانة - الغردقة", "طريق العين السخنة - القاهرة"],
    localNotes: ["أوناش هيدروليكية مجهزة للتعامل مع المرتفعات الجبلية بالعين السخنة وهضبة الجلالة.", "إمكانية نقل وسحب السيارة المتعطلة مباشرة من العين السخنة إلى أي مركز صيانة في القاهرة أو السويس."],
    faqs: [
      {
            "q": "هل توفرون خدمة سحب السيارات من العين السخنة إلى القاهرة؟",
            "a": "نعم، نوفر أوناش سطحة مجهزة لنقل سيارتك بأمان تام من السخنة وبورتو والجلالة إلى منزلك أو مركز الصيانة بالقاهرة."
      }
,
      {
        "q": "ما تكلفة نقل سيارة من القاهرة إلى العين السخنة؟",
        "a": "تكلفة النقل من القاهرة إلى العين السخنة تتراوح بين 800-1500 ج.م حسب نوع السيارة والمسافة الدقيقة."
      }],
    nearby: ["بورتو السخنة", "طريق العين السخنة", "السويس", "الزعفرانة", "العاصمة الإدارية"]
  },

  "بورتو السخنة": {
    tier: 2,
    title: "ونش انقاذ بورتو السخنة والجلالة",
    metaDescription: "ونش انقاذ بورتو السخنة: بورتو ساوث بيتش، تلفريك بورتو، مارينا الجلالة، الشاطئ العام. وصول 15 دقيقة خدمة 24 ساعة - 01044844492.",
    intro: "بورتو السخنة أشهر معالم العين السخنة السياحية. أوناش إنقاذ محمد بحر متمركزة أمام منتجع بورتو السخنة ومحطة التلفريك لخدمة المصطافين والنزلاء ورواد طريق الساحل طوال 24 ساعة.",
    responseTime: "15 دقيقة في بورتو السخنة",
    landmarks: ["منتجع بورتو السخنة Porto Sokhna", "محطة تلفريك بورتو السخنة", "بورتو ساوث بيتش Porto South Beach", "مارينا يخوت الجلالة", "فندق بورتو بيراميدز"],
    streets: ["طريق العين السخنة الساحلي", "طريق صعود الجلالة", "طريق الزعفرانة", "شارع مارينا دوم"],
    localNotes: ["أوناش متواجدة بجوار بوابات بورتو السخنة لسرعة الاستجابة لنداءات النزلاء والملاك.", "توفير خدمات سحب آمن للمركبات المعطلة على المنحدرات الجبلية الساحلية."],
    faqs: [
      {
            "q": "كم يستغرق وصول ونش الإنقاذ أمام بورتو السخنة؟",
            "a": "يصل الونش خلال أقل من 15 دقيقة لتواجدنا الدائم عند مدخل بورتو السخنة."
      }
,
      {
        "q": "هل تخدمون داخل بورتو السخنة والكمبوندات الساحلية؟",
        "a": "نعم، ندخل بورتو السخنة ومرسى السخنة والكمبوندات الساحلية بالتنسيق مع إدارة كل منتجع."
      }],
    nearby: ["العين السخنة", "طريق العين السخنة", "الزعفرانة", "السويس"]
  },

  "طريق الإسماعيلية": {
    tier: 1,
    title: "ونش انقاذ طريق مصر الإسماعيلية الصحراوي",
    metaDescription: "ونش انقاذ طريق الإسماعيلية: من موقف السلام والهايكستب حتى العبور، الشروق، العاشر من رمضان، والقصاصين والإسماعيلية. وصول 15 دقيقة - 01044844492.",
    intro: "طريق القاهرة - الإسماعيلية الصحراوي شريان التجارة والصناعة الأكبر في شرق الدلتا. نوفر أوناش إنقاذ متمركزة عند بوابات الرسوم ومداخل العبور والعاشر من رمضان لإنقاذ فوري للملاكي والنقل على مدار 24 ساعة.",
    responseTime: "15 دقيقة على طريق الإسماعيلية",
    landmarks: ["بوابة رسوم طريق الإسماعيلية (كارتة الإسماعيلية)", "سوق العبور للجملة", "المركز الطبي العالمي IMC", "مدخل العاشر من رمضان (الكيلو 54)", "مدينة العبور ومدينة الشروق", "محطة عدلي منصور"],
    streets: ["طريق القاهرة - الإسماعيلية الصحراوي", "طريق بلبيس الصحراوي", "محور 30 يونيو", "الدائري الإقليمي", "طريق الهايكستب"],
    localNotes: ["أوناش سطحة ثقيلة لنقل شاحنات البضائع وسيارات النقل وسيارات الملاكي.", "تأمين فوري للأعطال السريعة أمام المركز الطبي العالمي وكارتة الإسماعيلية ومداخل المصانع."],
    faqs: [
      {
            "q": "هل تغطون طريق الإسماعيلية حتى المركز الطبي العالمي والعاشر من رمضان؟",
            "a": "نعم، نغطي طريق الإسماعيلية بالكامل من موقف السلام حتى بوابات الإسماعيلية ومحور 30 يونيو."
      }
,
      {
        "q": "ما زمن الوصول إذا تعطلت سيارتي في منتصف طريق الإسماعيلية؟",
        "a": "نصلك في 30-45 دقيقة من مدخل القاهرة. ننصح بإضاءة الطوارئ والانتظار على الجانب الأيمن."
      }],
    nearby: ["العاشر من رمضان", "العبور", "الهايكستب", "الشروق", "الإسماعيلية", "مدينة السلام"]
  },

  "طريق الواحات": {
    tier: 1,
    title: "ونش انقاذ طريق الواحات 6 أكتوبر",
    metaDescription: "ونش انقاذ طريق الواحات: من ميدان الرماية وحدائق الأهرام حتى مول مصر، مدينة الإنتاج الإعلامي، سوق الجملة، دهشور. وصول 10-15 دقيقة - 01044844492.",
    intro: "طريق الواحات الشريان الرئيسي لمدينة 6 أكتوبر وحدائق الأهرام وحدائق أكتوبر. نوفر أوناش إنقاذ سريعة متمركزة أمام مول مصر ومدينة الإنتاج الإعلامي لإنقاذ فوري على مدار 24 ساعة.",
    responseTime: "10–15 دقيقة على طريق الواحات",
    landmarks: ["مول مصر Mall of Egypt", "مدينة الإنتاج الإعلامي Media Production City", "سوق الجملة المركزي بأكتوبر", "دريم لاند Dreamland", "جامعة MSA", "ميدان الرماية (بداية الواحات)", "أكاديمية الشرطة بأكتوبر"],
    streets: ["طريق الواحات الرئيسي", "طريق وصلة دهشور", "طريق زويل (حدائق أكتوبر)", "طريق الفيوم", "المحور المركزي أكتوبر"],
    localNotes: ["تمركز دائم أمام مول مصر ودريم لاند لسرعة نجدة السيارات في كافة الاتجاهات.", "أوناش سطحة مجهزة لنقل السيارات الفاخرة وسيارات الدفع الرباعي بأمان تام."],
    faqs: [
      {
            "q": "كم يستغرق وصول ونش الإنقاذ أمام مول مصر أو مدينة الإنتاج الإعلامي على طريق الواحات؟",
            "a": "من 10 إلى 15 دقيقة فقط لتمركز أوناشنا المباشر على طريق الواحات."
      }
,
      {
        "q": "هل تغطون الكيلومترات الأولى من طريق الواحات داخل محافظة الجيزة؟",
        "a": "نعم، من مدخل الدائري حتى الكيلو 20 على طريق الواحات مغطى بخدمتنا 24 ساعة."
      }],
    nearby: ["6 أكتوبر", "حدائق أكتوبر", "الشيخ زايد", "حدائق الأهرام", "وصلة دهشور", "دريم لاند"]
  },

  "طريق مصر إسكندرية الصحراوي": {
    tier: 1,
    title: "ونش انقاذ طريق مصر إسكندرية الصحراوي",
    metaDescription: "ونش انقاذ طريق إسكندرية الصحراوي: من بوابات القاهرة والقرية الذكية حتى وادي النطرون، السادات، النوبارية، وبوابات الإسكندرية. وصول 15-20 دقيقة - 01044844492.",
    intro: "طريق القاهرة - الإسكندرية الصحراوي الشريان القومي الأهم في مصر. ننشر أسطول أوناش إنقاذ متمركزة عند بوابات الرسوم (كارتة إسكندرية)، القرية الذكية، مخرج السادات، ورست وادي النطرون لإنقاذ فوري للمسافرين طوال 24 ساعة.",
    responseTime: "15–20 دقيقة على الصحراوي",
    landmarks: ["بوابة رسوم القاهرة الصحراوي (الكيلو 28)", "القرية الذكية Smart Village", "داندي مول Dandy Mega Mall", "استراحة رست ماستر ورست السادات", "مدخل وادي النطرون وطريق العلمين", "بوابات الإسكندرية الصحراوي (الكيلو 190)"],
    streets: ["طريق القاهرة - الإسكندرية الصحراوي الحر", "محور 26 يوليو", "طريق وصلة دهشور", "طريق وادي النطرون - العلمين", "طريق الخطاطبة"],
    localNotes: ["أوناش مجهزة للمسافات الطويلة والسرعات العالية مع إضاءات ليلية وأقماع لتأمين موقع العطل.", "سحب آمن وسريع للسيارات العادية والفارهة والكهربائية ونقلها لأي وجهة في القاهرة أو الإسكندرية."],
    faqs: [
      {
            "q": "هل تغطون طريق إسكندرية الصحراوي بالكامل حتى وادي النطرون والإسكندرية؟",
            "a": "نعم، لدينا أوناش متمركزة على طول الطريق الصحراوي من بوابات القاهرة حتى بوابات الإسكندرية والعلمين."
      }
,
      {
        "q": "ما زمن الوصول على الطريق الصحراوي إذا كانت السيارة متعطلة بعيداً عن المدينة؟",
        "a": "على الطريق الصحراوي خارج عمران الجيزة: نتوقع وصول 30-45 دقيقة. ننصح بتشغيل أضواء الطوارئ والانتظار على الرصيف."
      }],
    nearby: ["الشيخ زايد", "6 أكتوبر", "القرية الذكية", "وصلة دهشور", "الإسكندرية", "العلمين الجديدة"]
  },

  "محور 26 يوليو": {
    tier: 1,
    title: "ونش انقاذ محور 26 يوليو",
    metaDescription: "ونش انقاذ محور 26 يوليو: من ميدان لبنان والمهندسين حتى القرية الذكية، الشيخ زايد، وميدان جهينة بأكتوبر. وصول 10 دقائق خدمة 24/7 - 01044844492.",
    intro: "محور 26 يوليو الشريان السريع الرابط بين المهندسين ومحافظة الجيزة ومدينة الشيخ زايد و 6 أكتوبر. أوناش إنقاذ محمد بحر متمركزة عند ميدان لبنان، كوبري 15 مايو، ومخرج زايد وأكتوبر لإنقاذ فوري على مدار 24 ساعة.",
    responseTime: "10 دقائق على محور 26 يوليو",
    landmarks: ["ميدان لبنان والمهندسين (بداية المحور)", "نفق ومخرج المنصورية", "مخرج مدينة الشيخ زايد وهايبر وان", "مستشفى دار الفؤاد وجامعة MUST", "ميدان جهينة بأكتوبر", "القرية الذكية Smart Village"],
    streets: ["محور 26 يوليو السريع", "طريق إسكندرية الصحراوي", "وصلة دهشور", "المحور المركزي أكتوبر", "شارع السودان"],
    localNotes: ["تأمين الحوادث والأعطال السريعة على محور 26 يوليو وتفادي تعطيل حركة آلاف السيارات اليومية.", "أوناش سطحة هيدروليكية مجهزة لنقل السيارات الفاخرة والحديثة بدون احتكاك بالأرض."],
    faqs: [
      {
            "q": "كم يستغرق وصول ونش الإنقاذ على محور 26 يوليو قطاع الشيخ زايد أو ميدان لبنان؟",
            "a": "أقل من 10 دقائق لتواجد سياراتنا الدائم عند نقطتي الارتكاز بميدان لبنان ومدخل الشيخ زايد."
      }
,
      {
        "q": "هل تخدمون محور 26 يوليو من كوبري أكتوبر حتى مدخل 6 أكتوبر؟",
        "a": "نعم، محور 26 يوليو بالكامل من وسط البلد حتى وصلة دهشور وأول 6 أكتوبر مغطى 24 ساعة."
      }],
    nearby: ["ميدان لبنان", "المهندسين", "الشيخ زايد", "6 أكتوبر", "الحي المتميز", "طريق إسكندرية الصحراوي"]
  },

  "محور 30 يونيو": {
    tier: 2,
    title: "ونش انقاذ محور 30 يونيو الحر",
    metaDescription: "ونش انقاذ محور 30 يونيو: الطريق التبادلي السريع الرابط بين بورسعيد والإسماعيلية والسويس وطريق السخنة. وصول 15-20 دقيقة - 01044844492.",
    intro: "محور 30 يونيو هو المحور التبادلي الحر الموازي لقناة السويس والرابط بين بورسعيد ومحافظات القناة والدلتا وطريق العين السخنة. نوفر أوناش إنقاذ متمركزة على المحور لخدمة سيارات السفر والنقل على مدار 24 ساعة.",
    responseTime: "15–20 دقيقة على محور 30 يونيو",
    landmarks: ["بوابة رسوم محور 30 يونيو (بورسعيد)", "تقاطع محور 30 يونيو مع طريق الإسماعيلية", "تقاطع محور 30 يونيو مع طريق السويس", "تقاطع محور 30 يونيو مع طريق السخنة", "محطة وقود وطنية 30 يونيو"],
    streets: ["محور 30 يونيو الحر", "طريق بورسعيد - الإسماعيلية", "طريق القاهرة - السويس", "طريق القاهرة - العين السخنة", "طريق الإسماعيلية الصحراوي"],
    localNotes: ["أوناش سريعة ومخصصة للمسافات المفتوحة مع كامل تجهيزات الأمان والقطر والرفع.", "توفير خدمات سحب فورية لسيارات الملاكي والشاحنات التجارية العابرة بين موانئ بورسعيد والسخنة."],
    faqs: [
      {
            "q": "هل تغطون محور 30 يونيو بين بورسعيد وطريق السخنة؟",
            "a": "نعم، نغطي محور 30 يونيو بالكامل وتصلك أوناشنا فوراً عند أي نقطة على المحور."
      }
,
      {
        "q": "هل تخدمون محور 30 يونيو من الدائري حتى طريق السادات؟",
        "a": "نعم، محور 30 يونيو بالكامل من تقاطع الدائري حتى مدخل العاصمة الإدارية مغطى 24 ساعة."
      }],
    nearby: ["بورسعيد", "الإسماعيلية", "السويس", "العين السخنة", "طريق الإسماعيلية"]
  },

  "طريق القطامية": {
    tier: 2,
    title: "ونش انقاذ طريق القطامية القديم والجديد",
    metaDescription: "ونش انقاذ طريق القطامية: من المعادي وزهراء المعادي حتى التجمع الثالث ومحمية وادي دجلة ومصانع الأسمنت. وصول 10-15 دقيقة - 01044844492.",
    intro: "طريق القطامية يربط بين المعادي وزهراء المعادي والتجمع الثالث وطريق السخنة. أوناشنا متمركزة على الطريق لتوفير إنقاذ سريع للمركبات وسحب سيارات النقل والملاكي بأفضل الأسعار.",
    responseTime: "10–15 دقيقة على طريق القطامية",
    landmarks: ["محمية وادي دجلة الطبيعية", "مصانع أسمنت القطامية والمنطقة الصناعية", "جمارك القطامية للسيارات", "ميدان مسجد الشهيد بالقطامية", "كمبوند القطامية هايتس"],
    streets: ["طريق القطامية الرئيسي", "طريق العين السخنة القديم", "شارع الخمسين المعادي", "محور جمال عبد الناصر التجمع الثالث"],
    localNotes: ["أوناش مجهزة للتعامل مع الطبيعة الجبلية ومداخل المنطقة الصناعية بالقطامية.", "توفير خدمات سحب فورية ورفع آمن للمركبات العالقة أو المتعطلة."],
    faqs: [
      {
            "q": "كم يستغرق وصول ونش الإنقاذ على طريق القطامية؟",
            "a": "يصل الونش خلال 10 إلى 15 دقيقة من أقرب نقطة تمركز بزهراء المعادي أو التجمع الثالث."
      }
,
      {
        "q": "ما الفرق بين خدمة طريق القطامية وطريق السويس للأعطال السريعة؟",
        "a": "كلاهما مغطى — على القطامية نصل في 15-20 دقيقة، وعلى السويس في 15-25 دقيقة حسب موقع العطل."
      }],
    nearby: ["القطامية", "زهراء المعادي", "المعادي", "التجمع الثالث", "الهضبة الوسطى", "طريق السخنة"]
  },

  "نفق أحمد حمدي": {
    tier: 2,
    title: "ونش انقاذ نفق أحمد حمدي 1 و 2",
    metaDescription: "ونش انقاذ نفق أحمد حمدي: بوابات النفق، شرق وغرب قناة السويس، رأس سدر، طريق شرم الشيخ، السويس. وصول 15-20 دقيقة - 01044844492.",
    intro: "نفق الشهيد أحمد حمدي (1 و 2) بوابة العبور البرية الاستراتيجية بين أفريقيا وشبه جزيرة سيناء. نوفر أوناش إنقاذ متمركزة عند مداخل ومخارج النفق في السويس وشرق القناة لخدمة المسافرين وقوافل السياحة والتجارة على مدار 24 ساعة.",
    responseTime: "15–20 دقيقة عند نفق أحمد حمدي",
    landmarks: ["بوابة نفق أحمد حمدي (المدخل الغربي بالسويس)", "بوابة نفق أحمد حمدي (المدخل الشرقي بسيناء)", "نفق أحمد حمدي 2 الجديد", "نقطة تفتيش ورسوم النفق", "طريق رأس سدر وشرم الشيخ الدولي"],
    streets: ["طريق نفق الشهيد أحمد حمدي", "طريق السويس - الإسماعيلية", "طريق رأس سدر الدولي (عيون موسى)", "طريق السويس - القاهرة"],
    localNotes: ["أوناش مجهزة للتدخل السريع عند مداخل ومخارج النفق وتأمين حركة السير.", "جاهزية كاملة لسحب السيارات المسافرة إلى مدن جنوب سيناء (رأس سدر، الطور، شرم الشيخ)."],
    faqs: [
      {
            "q": "هل يتوفر ونش إنقاذ عند بوابات نفق أحمد حمدي بالسويس؟",
            "a": "نعم، أوناشنا متواجدة عند بوابات نفق أحمد حمدي 1 و 2 على مدار 24 ساعة."
      }
,
      {
        "q": "ما هو الإجراء المتبع إذا تعطلت سيارتي داخل نفق أحمد حمدي؟",
        "a": "في حالة أي عطل داخل النفق: أوقف السيارة على الجانب، أضئ الطوارئ، ثم اتصل بنا فوراً. لدينا ترتيب مع إدارة النفق لاستجابة آمنة وسريعة."
      }],
    nearby: ["السويس", "العين السخنة", "رأس سدر", "طريق السويس", "الإسماعيلية"]
  },

  "التجمع الأول": {
    tier: 2,
    title: "ونش انقاذ التجمع الأول",
    metaDescription: "ونش انقاذ التجمع الأول: حي البنفسج، الياسمين، القرنفل، محور السادات، السوق الشرقي. وصول 10-15 دقيقة بخصم 50% - اتصل الآن 01044844492.",
    intro: "تغطية فورية لإنقاذ السيارات في التجمع الأول، نصلك في غضون 10 إلى 15 دقيقة في أحياء البنفسج، الياسمين، القرنفل، سوان ليك، ومحيط أكاديمية الشرطة ومحور السادات على مدار 24 ساعة.",
    responseTime: "10–15 دقيقة في التجمع الأول",
    landmarks: ["أكاديمية الشرطة", "السوق الشرقي بالتجمع الأول", "ميدان مسجد حسن الشربتلي", "محور السادات", "منطقة خدمات البنفسج"],
    streets: ["محور السادات", "شارع أحمد شوقي", "شارع التسعين الشمالي (مدخل الأول)", "محور مصطفى كامل", "شارع الياسمين"],
    localNotes: ["تمركزات مباشرة بالقرب من أكاديمية الشرطة ومدخل الرحاب تضمن سرعة التحرك للشوارع الداخلية والكمبوندات السكنية.", "معدات رفع هيدروليكية لحماية السيارات المنخفضة من المطبات الصناعية المرتفعة بشوارع التجمع الأول.", "تنسيق أمني سريع مع بوابات الكمبوندات للدخول وسحب السيارات المعطلة دون تعطيل العميل."],
    faqs: [
      {
            "q": "هل يصل الونش إلى حي البنفسج والياسمين بالتجمع الأول وقت الذروة؟",
            "a": "نعم، أوناشنا متواجدة داخل نطاق التجمع الأول وتصلك خلال 10 إلى 15 دقيقة بحد أقصى."
      },
      {
            "q": "ما العمل لو تعطل فتيس السيارة الأوتوماتيك داخل كمبوند؟",
            "a": "نستخدم حوامل عجل هيدروليكية لرفع العجلات القائدة ونقل السيارة دون جر الفتيس لتفادي أي تلف ميكانيكي."
      }
],
    nearby: ["التجمع الخامس", "الرحاب", "شارع التسعين", "مدينة نصر", "طريق السويس"]
  },

  "محور محمد نجيب": {
    tier: 2,
    title: "ونش انقاذ محور محمد نجيب القاهرة الجديدة",
    metaDescription: "ونش انقاذ محور محمد نجيب: من طريق السويس حتى طريق السخنة، ووتر واي 2، ديار، النرجس، المستثمرين. وصول 10 دقائق - 01044844492.",
    intro: "محور محمد نجيب الشريان الطولي الرئيسي بالقاهرة الجديدة الرابط بين طريق السويس وطريق العين السخنة مروراً بالتسعين الشمالي والجنوبي. أوناشنا متمركزة على طول المحور لإنقاذ فوري على مدار 24 ساعة.",
    responseTime: "10 دقائق على محور محمد نجيب",
    landmarks: ["كمبوند ديار صبور", "مول ووتر واي 2 Waterway", "تقاطع نجيب مع التسعين الشمالي والجنوبي", "ميدان مصطفى كامل", "محيط نادي الزهور التجمع"],
    streets: ["محور محمد نجيب الرئيسي", "شارع التسعين الشمالي", "شارع التسعين الجنوبي", "محور جمال عبد الناصر", "طريق السويس"],
    localNotes: ["أوناش سريعة لنقل السيارات الفاخرة والكهربائية على المحور الحر بأمان تام.", "تأمين فوري للأعطال السريعة عند تقاطعات التسعين والنرجس والبنفسج."],
    faqs: [
      {
        "q": "كم يستغرق وصول ونش الإنقاذ على محور محمد نجيب؟",
        "a": "يصل الونش خلال أقل من 10 دقائق لتواجد سياراتنا المستمر على المحور."
      }
    ,
      {
        "q": "كيف تصلون لمنتصف محور محمد نجيب إذا كانت السيارة في الحارة الوسطى؟",
        "a": "لدينا أوناش مجهزة للعمل على المحاور السريعة — نصل بأمان وننتشل السيارة بإجراءات السلامة الكاملة."
      }],
    nearby: ["التجمع الخامس", "التجمع الأول", "شارع التسعين", "الرحاب", "طريق السويس"]
  },

  "شبرا الخيمة": {
    tier: 1,
    title: "ونش انقاذ شبرا الخيمة",
    metaDescription: "ونش انقاذ شبرا الخيمة: كوبري عرابي، مسطرد، شارع 15 مايو، محطة مترو شبرا الخيمة، بهتيم، قصر محمد علي. وصول 10-15 دقيقة - 01044844492.",
    intro: "ونش إنقاذ شبرا الخيمة وميدان المؤسسة ومطلع الطريق الزراعي ومسطرد وبهتيم؛ خدمة سريعة لسيارات الملاكي والنقل 24 ساعة بأفضل الأسعار.",
    responseTime: "10 دقائق في شبرا الخيمة",
    landmarks: ["محطة مترو شبرا الخيمة ومحطة القطار", "كوبري أحمد عرابي العلوي", "مستشفى بهتيم المركزي", "مجمع مصانع مسطرد وبترول مسطرد", "قصر محمد علي بشبرا الخيمة", "ميدان المؤسسة بشبرا الخيمة"],
    streets: ["شارع 15 مايو (شبرا الخيمة)", "شارع أحمد عرابي", "طريق مصر - إسكندرية الزراعي (مدخل شبرا الخيمة)", "شارع ترعة الإسماعيلية مسطرد", "شارع بهتيم العام"],
    localNotes: ["تمركز حيوي عند ميدان المؤسسة ومطلع طريق مصر إسكندرية الزراعي لتأمين سيارات المسافرين والنقل.", "التعامل مع أعطال سيارات النقل والجامبو والملاكي على محور العصار وشارع 15 مايو.", "إمكانية نقل السيارات المعطلة لمحافظات الدلتا (بنها، طنطا) أو مجمعات الصيانة بالقاهرة."],
    faqs: [
      {
            "q": "كم يستغرق الونش للوصول إلى ميدان المؤسسة بشبرا الخيمة؟",
            "a": "من 8 إلى 12 دقيقة لوجود سيارة إنقاذ متمركزة بالقرب من كوبري المؤسسة ومطلع الزراعي."
      },
      {
            "q": "هل تنقذون السيارات المعطلة على أول طريق إسكندرية الزراعي؟",
            "a": "نعم، بداية الطريق الزراعي حتى كوبري قها وسندنهور ضمن نطاق تغطيتنا الميدانية المباشرة."
      }
],
    nearby: ["شبرا", "قليوب", "المطرية", "مسطرد", "الطريق الدائري", "موقف عبود"]
  },

  "حدائق القبة": {
    tier: 2,
    title: "ونش انقاذ حدائق القبة وسراي القبة",
    metaDescription: "ونش انقاذ حدائق القبة: كوبري القبة، شارع مصر والسودان، قصر القبة، محطة مترو حدائق القبة، كوبري طومان باي. وصول 10 دقائق - 01044844492.",
    intro: "حي حدائق القبة التاريخي العريق بقلب شمال القاهرة. نوفر أوناش إنقاذ متمركزة في شارع مصر والسودان ومحيط قصر القبة الرئاسي ومحطة المترو وكوبري طومان باي لإنقاذ فوري على مدار 24 ساعة.",
    responseTime: "10 دقائق في حدائق القبة",
    landmarks: ["قصر القبة الرئاسي التاريخي", "محطة مترو حدائق القبة وسراي القبة", "مستشفى وادي النيل التخصصي", "كوبري القبة العلوي وكوبري طومان باي", "شارع مصر والسودان التجاري", "ميدان بكري"],
    streets: ["شارع مصر والسودان", "شارع ترعة الجبل", "شارع سكة الوايلي", "شارع ابن سندر", "شارع الشيخ غراب"],
    localNotes: ["أوناش متواجدة عند كوبري القبة ومصر والسودان للوصول السريع نحو الزيتون أو الوايلي أو مصر الجديدة.", "سحب آمن وسريع للمركبات ونقلها لمراكز الصيانة المعتمدة."],
    faqs: [
      {
        "q": "هل يتوفر ونش إنقاذ بشارع مصر والسودان أو أمام مستشفى وادي النيل بحدائق القبة؟",
        "a": "نعم، أوناشنا متواجدة على مدار 24 ساعة بشارع مصر والسودان وميدان القبة."
      }
    ,
      {
        "q": "هل تغطون منطقة حدائق القبة القديمة وسراي القبة؟",
        "a": "نعم، حدائق القبة وسراي القبة ومنطقة مصطفى النحاس الشمالية مغطاة بخدمتنا الكاملة."
      }],
    nearby: ["الزيتون", "سراي القبة", "مصر الجديدة", "الوايلي", "العباسية", "غمرة"]
  }
};
